// eslint-disable
import api from 'configs/api'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { Grid } from '@mui/material'
import {
  addMinutes,
  differenceInMilliseconds,
  differenceInMinutes,
  formatDistanceToNow,
  parseISO,
  subHours,
} from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { formatLocal, formatUTC } from 'utils/date'
import useStorage from 'hooks/storageSync'
import { telephoneMask } from 'js-essentials-functions'
import { normalizeName } from 'utils'

import { translate } from 'locales'

import { calcIMC } from 'utils/convert'
import { alertSuccess } from 'utils/toast'

// Utils
import PublicIcon from '@mui/icons-material/Public'
import alertCircleIcon from 'assets/icons/alert-circle-outline.png'
import videoIcon from 'assets/icons/video.svg'
import whatsappIcon from 'assets/icons/whatsapp.svg'
import {
  Button,
  Card,
  Header,
  Loading,
  ModalShow,
  SideModal,
  VideoCallMeet,
  VideoPermissions,
} from 'components'
import {
  cancelReasonRequiresDetail,
  cancelReasonToAnalyticsKey,
} from 'components/Modal/cancelReasons'
import StartService from 'components/Modal/StartService'
import * as Global from 'global/styles.global'
import useFetch, { useSWRConfig } from 'hooks/useFetch'
import { useMedicalRecordChatEnabled } from 'hooks/useMedicalRecordChatEnabled'
import getAge from 'utils/getAge'
import { useTwilioServiceRoomChat } from 'hooks/useTwilioServiceRoomChat'
import ChatPatient from '../New/ChatPatient'
import { menuItems } from './utils'

// Styles
import * as S from './styles'

// Components
import Analysis from './Analysis'
import AnamneseNutri from './AnamneseNutri'
import FoodMenu from './FoodMenu'
import History from './History'
import NutritionalGuidance from './NutritionalGuidance'
import PsychologicalGuidance from './PsychologicalGuidance'
import Resume from './Resume'
import Scheduling from './Scheduling'
import TermsPsico from './TermsPsico'

// Services
import {
  // findSchedule,
  CancelSchedule,
  InitSchedule,
  initVideoCall,
  sendCallPush,
} from '../New/services'

import { saveMedicalRecord } from './services'
import { encerrarConversaDoPar } from 'services/conversations/closeOnFinish'
import { prepararConversaDoPar } from 'services/conversations/startOnAttendance'
import { decidirReinicioDoChat } from './chatReinit'

import ImagesAndAttachments from './ImagesAndAttachments'
import { openVideoCallRating } from 'modal/modals'
import videoCallRatingAnalytics from 'services/analytics/VideoCallRating/videoCallRatingAnalytics'
import {
  VideoCallRatingPrompt,
  wasVideoCallRatingSubmitted,
} from 'ui/VideoCallRating'
import { VideoRoomSession } from 'types/videoRoomSesssion'

// Icons

const NewMedicalRecord = () => {
  const topContentRef = useRef<HTMLDivElement>(null)
  const params: any = useParams()
  const history = useHistory()
  const { mutate } = useSWRConfig()

  const [storage]: any = useStorage(params.scheduleUUID, '')

  // State
  const [cancelDescription, setCancelDescription] = useState('')
  const [customDescription, setCustomDescription] = useState<string>('')

  const [showCancelModal, setShowCancelModal] = useState('none')
  /** `true` quando `prepararConversaDoPar` deixou a conversa pronta ao iniciar. */
  const [conversaPreparada, setConversaPreparada] = useState(false)
  const [showFinishModal, setShowFinishModal] = useState('none')
  const [showInitModal, setShowInitModal] = useState('none')
  const [showSchedulingModal, setShowSchedulingModal] = useState(false)
  const [showPermissionsModal, setShowPermissionsModal] = useState(false)
  const [showPermissions, setShowPermissions] = useState({
    camera: false,
    microphone: false,
  })
  const [selectedMenu, setSelectedMenu] = useState(1)
  const [loading, setLoading] = useState(false)
  const [windowHeight, setWindowHeight] = useState(window.innerHeight)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const [state, setState] = useState({
    showModal: false,
    message: '',
    url: '',
  })
  const [roomSession, setRoomSession] = useState<VideoRoomSession | null>(null)
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)
  const [timeRemaining, setTimeRemaining] = useState<number | null>(null)
  const [timeVideo, setTimeVideo] = useState<string | null>(null)
  const [showVideoCallRatingPrompt, setShowVideoCallRatingPrompt] =
    useState(false)
  const [isMealPlanSent, setIsMealPlanSent] = useState<boolean>(false)
  const [showPsicoReminder, setShowPsicoReminder] = useState<boolean>(() => {
    const dismissed = localStorage.getItem('psicoReminderDismissed')
    return !dismissed
  })
  const [videoCallOver2Min, setVideoCallOver2Min] = useState<boolean>(false)
  // const [accompaniment, setAccompaniment] =
  //   useState<IAccompaniment>(defaultAccompaniment)

  const medicalRecordChatEnabled = useMedicalRecordChatEnabled()

  const { data: appointment, isLoading } = useFetch({
    url: `/schedulings/ms/v1/${params?.scheduleUUID}/doctor`,
  })

  const { data: userData } = useFetch({
    url: `accounts/ms/v1/user/${appointment?.user_id}/me`,
    condition: !!appointment?.user_id,
    options: {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  })
  const { data: userMedical } = useFetch({
    url: `accounts/v1/medical-record/user/${appointment?.user_id}`,
    condition: !!appointment?.user_id,
    options: {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  })

  const { data: userCredits } = useFetch({
    url: `payments/ms/v1/appointments/credits?user_id=${appointment?.user_id}&specialty_slug=${appointment?.specialty_slug}`,
    condition: !!appointment?.user_id && !!appointment?.specialty_slug,
    options: {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  })

  const { data: planDetails } = useFetch({
    url: `payments/ms/v1/subscriptions/${appointment?.plan_associate_id}/plan-details`,
    condition: !!appointment?.plan_associate_id,
    options: {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  })
  const isBr = appointment?.user_country === 'BR'

  const hasCredits = userCredits?.credits > 0 || false

  const isTotalpass = (() => {
    return !!planDetails?.enable_next_appointment
  })()

  const verifySavedCallToken = useCallback(() => {
    const callRoomSession = localStorage.getItem('callRoomSession')
    const callAppointmentId = localStorage.getItem('callAppointmentId')

    if (callRoomSession && callAppointmentId === params.scheduleUUID) {
      setRoomSession(JSON.parse(callRoomSession) as VideoRoomSession)
    }
  }, [params.scheduleUUID])

  const clearVideoCallSession = useCallback(() => {
    localStorage.removeItem('callToken')
    localStorage.removeItem('callAppointmentId')
    setRoomSession(null)
  }, [])

  const dispatchMeetVideoCallRating = useCallback((schedulingId: string) => {
    videoCallRatingAnalytics.trackCallExitTriggered(schedulingId)
    if (wasVideoCallRatingSubmitted(schedulingId)) return
    setShowVideoCallRatingPrompt(true)
  }, [])

  useEffect(() => {
    const handleSize = () => {
      setWindowHeight(window.innerHeight)
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleSize)

    return () => {
      window.removeEventListener('resize', handleSize)
    }
  }, [])

  useEffect(() => {
    verifySavedCallToken()
  }, [])

  useEffect(() => {
    const checkMealPlanSent = async () => {
      try {
        if (appointment?.id) {
          const response = await api.get(
            `/stela-meal/v1/meal-menu/appointment/${appointment.id}`
          )
          setIsMealPlanSent(!!response.data)
        }
      } catch {
        setIsMealPlanSent(false)
      }
    }

    checkMealPlanSent()
  }, [appointment?.id])

  useEffect(() => {
    const calculateTimeRemaining = () => {
      if (!appointment?.from_date_time) return
      const now = subHours(new Date(), 3)
      const start = parseISO(appointment.from_date_time)
      const difference = differenceInMilliseconds(start, now) - 3 * 60 * 1000

      if (difference <= 0) {
        setIsButtonDisabled(false)
        setTimeRemaining(0)
      } else {
        setTimeRemaining(difference)
        if (difference <= 0) {
          setIsButtonDisabled(false)
        } else {
          setIsButtonDisabled(true)
        }
      }
    }

    calculateTimeRemaining()

    const intervalId = setInterval(() => {
      calculateTimeRemaining()
    }, 1000)

    return () => clearInterval(intervalId)
  }, [appointment?.from_date_time])

  const formatTime = (milliseconds: number) => {
    const totalSeconds = Math.floor(milliseconds / 1000)
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60
    const remaining = `${hours}:${minutes < 10 ? '0' : ''}${minutes}:${
      seconds < 10 ? '0' : ''
    }${seconds}`

    if (milliseconds <= 0) {
      return {
        duration: 'menos de 3 minutos',
        remaining,
      }
    }

    const duration = formatDistanceToNow(
      addMinutes(new Date(), milliseconds / 60000),
      { includeSeconds: false, locale: ptBR }
    )

    return {
      duration,
      remaining,
    }
  }

  const hideModal = () => {
    // @ts-ignore
    setShowCancelModal('none')
  }

  const hideFinishModal = () => {
    setShowFinishModal('none')
  }
  const hideInitModal = () => {
    setShowInitModal('none')
  }

  const handleUpdateData = () => {
    mutate(`/schedulings/ms/v1/${params?.scheduleUUID}/doctor`)
    mutate(
      `payments/ms/v1/appointments/credits?user_id=${appointment?.user_id}&specialty_slug=${appointment?.specialty_slug}`
    )
  }

  /** Par da conversa — mesmos campos que o ChatPatient usa para abrir o chat. */
  const parDaConversa = () => {
    const a = appointment as Record<string, string | undefined> | undefined
    return { personId: a?.person_id, professionalId: a?.doctor_id }
  }

  const handleInitService = useCallback(() => {
    InitSchedule({
      scheduleUUID: appointment?.id,
      data: {
        status: 'started',
      },
      setLoading,
      history,
      action: handleUpdateData,
    })

    // Prepara a conversa junto com o início — sem isto ela só nasce quando a
    // aba de chat abre, e o profissional só vira participante nesse momento.
    const par = parDaConversa()
    void prepararConversaDoPar(par.personId, par.professionalId).then(
      (resultado) => {
        if (resultado === 'pronta' || resultado === 'somente-leitura') {
          setConversaPreparada(true)
        }
      }
    )
  }, [history, appointment])

  const handleCancelSchedule = useCallback(() => {
    let cancelDescriptionValue = cancelDescription
    let cancelReasonValue = customDescription

    if (cancelReasonRequiresDetail(cancelDescription)) {
      cancelDescriptionValue = customDescription
      cancelReasonValue = cancelDescription
    } else {
      cancelDescriptionValue = cancelDescription
      cancelReasonValue = cancelDescription
    }

    CancelSchedule({
      scheduleUUID: appointment?.id,
      data: {
        cancel_description: cancelDescriptionValue,
        cancel_reason: cancelReasonValue,
      },
      setLoading,
      history,
      // Cancelar também encerra o chat: o atendimento acabou, por outro
      // desfecho. O `reason` distingue os dois no log de auditoria.
      aoCancelar: () => {
        const par = parDaConversa()
        return encerrarConversaDoPar(
          par.personId,
          par.professionalId,
          'atendimento_cancelado'
        )
      },
      action: handleUpdateData,
      analyticsContext: appointment?.id
        ? {
            source: 'medical_record_analysis',
            cancelReasonKey: cancelReasonToAnalyticsKey(cancelDescription),
            hasCustomDetail:
              cancelReasonRequiresDetail(cancelDescription) &&
              Boolean(customDescription?.trim()),
          }
        : undefined,
    })
  }, [history, appointment, cancelDescription, customDescription])

  const handleOpenWhatsApp = () => {
    const ddi = appointment?.user_cellphone?.includes('+')
      ? ''
      : isBr
        ? '55'
        : '1'

    window.open(`https://wa.me/${ddi}${appointment?.user_cellphone}`, '_blank')
  }

  const handleSaveMedicalRecord = async () => {
    setShowFinishModal('none')

    const data = {
      user_uuid: appointment?.user_id,
      schedule_uuid: appointment?.id,
      specialty: appointment?.specialty_id,
      ...storage?.analysis,
      ...storage?.tags,
      nutritional_anamnese: storage?.nutritional_anamnese,
    }
    const par = parDaConversa()
    saveMedicalRecord(
      appointment?.user_id,
      appointment?.id,
      data,
      history,
      setLoading,
      appointment?.specialty_slug,
      () => encerrarConversaDoPar(par.personId, par.professionalId)
    )
  }
  const handleScrollToTop = () => {
    if (topContentRef.current) {
      setTimeout(() => {
        topContentRef.current?.scrollIntoView({ behavior: 'smooth' })
      }, 500)
    }
  }

  const doctorName = appointment?.doctor_name

  const personIdRaw = appointment?.person_id
  const personIdForChat =
    personIdRaw != null && String(personIdRaw).trim() !== ''
      ? String(personIdRaw).trim()
      : undefined
  const professionalIdForChat = appointment?.doctor_id
  const appointmentTwilio = appointment as
    | Record<string, string | undefined>
    | undefined
  const twilioConversationSidForChat =
    appointmentTwilio?.twilio_conversation_sid ??
    appointmentTwilio?.twilioConversationSid

  const twilioChatForMenu = useTwilioServiceRoomChat({
    personId: personIdForChat,
    professionalId: professionalIdForChat,
    twilioAs: 'professional',
    twilioConversationSid: twilioConversationSidForChat,
    appointmentId: appointment?.id,
    enabled:
      !!(personIdForChat && professionalIdForChat) && medicalRecordChatEnabled,
  })

  useEffect(() => {
    if (!medicalRecordChatEnabled && selectedMenu === 0) {
      setSelectedMenu(1)
    }
  }, [medicalRecordChatEnabled, selectedMenu])

  useEffect(() => {
    if (!medicalRecordChatEnabled) return
    if (selectedMenu !== 0) return
    if (twilioChatForMenu.status !== 'ready') return
    void twilioChatForMenu.markAsRead()
  }, [
    selectedMenu,
    twilioChatForMenu.status,
    twilioChatForMenu.messages,
    twilioChatForMenu.markAsRead,
    medicalRecordChatEnabled,
  ])

  /** Reabrir em `prepararConversaDoPar` não reconecta o chat: ver `chatReinit`. */
  const { status: twilioChatStatus, reinitialize: reinitTwilioChat } =
    twilioChatForMenu
  useEffect(() => {
    const { reiniciar, limpar } = decidirReinicioDoChat(
      conversaPreparada,
      twilioChatStatus
    )
    if (reiniciar) reinitTwilioChat()
    if (limpar) setConversaPreparada(false)
  }, [conversaPreparada, twilioChatStatus, reinitTwilioChat])

  const verifyScrren: any = window.screen.width < 600

  const handleClickTime = async () => {
    try {
      await api.patch(`/schedulings/ms/v1/${appointment?.id}/doctor/video`)
      handleUpdateData()
    } catch (error) {
      console.error(error)
    }
  }

  const verifyTimeVideo = () => {
    const CancelInMinutes = appointment?.video_starts_at
      ? differenceInMinutes(new Date(), new Date(appointment?.video_starts_at))
      : 0

    if (
      !appointment?.video_starts_at &&
      differenceInMinutes(new Date(), new Date(appointment?.from_date_time)) >
        200
    ) {
      return false
    } else {
      return appointment?.specialty_slug === 'clinico-geral'
        ? CancelInMinutes < 3
        : CancelInMinutes < 5
    }
  }

  const handleDismissPsicoReminder = () => {
    localStorage.setItem('psicoReminderDismissed', 'true')
    setShowPsicoReminder(false)
  }

  const handleCopyPsicoLink = async () => {
    try {
      await navigator.clipboard.writeText(
        'https://ewkc0m99i9u.typeform.com/to/WhFrdAR5'
      )
      alertSuccess('Link copiado com sucesso!')
    } catch {
      const textArea = document.createElement('textarea')
      textArea.value = 'https://ewkc0m99i9u.typeform.com/to/WhFrdAR5'
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
      alertSuccess('Link copiado com sucesso!')
    }
  }

  useEffect(() => {
    const calculateTimeVideo = () => {
      if (appointment?.video_starts_at) {
        const diference = differenceInMilliseconds(
          new Date(),
          new Date(appointment?.video_starts_at)
        )

        const totalSeconds = Math.floor(diference / 1000)
        const hours = Math.floor(totalSeconds / 3600)
        const minutes = Math.floor((totalSeconds % 3600) / 60)
        const seconds = totalSeconds % 60

        if (totalSeconds >= 1500) {
          setVideoCallOver2Min(true)
        } else {
          setVideoCallOver2Min(false)
        }

        if (seconds >= 0) {
          setTimeVideo(
            `${hours ? `${hours}h` : ''} ${minutes}m ${seconds < 10 ? '0' : ''}${seconds}s`
          )
        }
      } else {
        setTimeVideo('')
        setVideoCallOver2Min(false)
      }
    }

    calculateTimeVideo()
    const intervalId = setInterval(() => {
      calculateTimeVideo()
    }, 1000)

    return () => clearInterval(intervalId)
  }, [appointment?.video_starts_at])

  return (
    <S.Container>
      <div ref={topContentRef} />
      {(isLoading || loading) && (
        <Loading
          title={state.message || translate('medicalRecord.loadingData')}
        />
      )}
      <Header openNewTab={!!roomSession?.token} />
      <S.Content>
        <S.LeftContainer
          windowHeight={windowHeight}
          windowWidth={windowWidth}
          isCenter={!!roomSession?.token}
        >
          <S.GridContent container xl={12}>
            <Grid
              item
              xs={12}
              md={12}
              style={{ paddingLeft: 16, paddingRight: 16 }}
            >
              <S.MessageContainer>
                <S.MessageText>
                  <b>🚨 Atenção: </b> Durante a videochamada com o paciente, é
                  essencial permanecer na tela para garantir uma comunicação
                  contínua e sem interrupções. Sair da tela pode causar
                  problemas na transmissão de vídeo e áudio.
                </S.MessageText>
                <S.MessageText>
                  🚨 <b>Observação: </b> Enquanto a consulta por vídeo estiver
                  acontecendo não será possível finalizar ou cancelar o
                  atendimento!
                </S.MessageText>
                <S.MessageText>
                  <b>
                    🌟 Por favor, permaneça na tela enquanto a chamada estiver
                    ativa para oferecer a melhor experiência de atendimento ao
                    seu paciente. 🌟
                  </b>
                </S.MessageText>
              </S.MessageContainer>
            </Grid>
            <Grid
              item
              xs={12}
              md={3}
              style={{
                padding: '2px 6px',
                borderRightWidth: 1,
                borderRightColor: '#f0f2f8',
                borderRightStyle: 'solid',
                order: verifyScrren ? 2 : 1,
              }}
            >
              <Card styles={{ padding: 0 }}>
                {showVideoCallRatingPrompt && appointment?.id && (
                  <VideoCallRatingPrompt
                    appointmentId={String(appointment.id)}
                    onOpenRating={(initialSentiment) => {
                      setShowVideoCallRatingPrompt(false)
                      openVideoCallRating({
                        schedulingId: String(appointment.id),
                        initialSentiment: initialSentiment ?? null,
                        fromCallEnd: true,
                        source: 'side_prompt',
                      })
                    }}
                  />
                )}
                <S.TopContent>
                  <div className="text-content">
                    <span>{translate('medicalRecord.attendance')}</span>
                    <p>
                      {formatUTC(
                        appointment?.from_date_time,
                        'dd/MM/yyyy HH:mm'
                      )}
                    </p>
                  </div>

                  <div className="text-content">
                    <span>{translate('medicalRecord.time')}</span>
                    <p style={{ color: 'red' }}>
                      {`${appointment?.quantity_slot === 2 ? 60 : 30} ${translate(
                        'medicalRecord.minutes'
                      )}`}
                    </p>
                  </div>
                  <div className="text-content">
                    <span>WhatsApp</span>
                    <p>
                      {`${
                        isBr
                          ? telephoneMask(appointment?.user_cellphone || '')
                          : `${appointment?.user_cellphone?.includes('+') ? '' : '+1'} ${appointment?.user_cellphone}`
                      }`}
                    </p>
                  </div>
                  <div className="button-content">
                    {timeRemaining !== null && timeRemaining > 0 && (
                      <S.MessageContainer>
                        <S.MessageText>
                          🚨 Por favor, aguarde. O atendimento só poderá ser
                          iniciado 3 minutos antes do horário da consulta, sendo
                          assim você poderá iniciar a consulta em{' '}
                          <b>{formatTime(timeRemaining).duration}</b>.
                        </S.MessageText>
                        <S.MessageText>
                          <b>Tempo restante:</b>{' '}
                          {formatTime(timeRemaining).remaining}
                        </S.MessageText>
                      </S.MessageContainer>
                    )}
                    {timeVideo && (
                      <S.MessageText>
                        <b>Tempo de atendimento:</b> {timeVideo}
                      </S.MessageText>
                    )}
                    {appointment?.status === 'pending' && (
                      <Button
                        color="primary"
                        type="button"
                        size="normal"
                        styles={{ width: '100%', marginBottom: 10 }}
                        onClick={() => setShowInitModal('block')}
                        disabled={isButtonDisabled}
                      >
                        {translate('medicalRecord.initAttendance')}
                      </Button>
                    )}

                    {appointment?.status === 'started' && (
                      <>
                        <p
                          style={{
                            marginTop: 10,
                            marginBottom: 16,
                            fontSize: '0.875rem',
                            color: '#f48c42',
                            backgroundColor: '#fff5ec',
                            padding: '10px',
                            borderRadius: '10px',
                            textAlign: 'center',
                          }}
                        >
                          Os botões para cancelar ou finalizar a consulta só
                          estarão disponíveis após o cronômetro atingir{' '}
                          {appointment?.specialty_slug === 'clinico-geral'
                            ? '3'
                            : '5'}{' '}
                          minutos e o profissional encerrar a chamada de vídeo.
                          A contagem do tempo se inicia quando o botão{' '}
                          {'"Iniciar Vídeo"'} for acionado..
                        </p>
                        <Button
                          color="primary"
                          type="button"
                          size="normal"
                          styles={{ width: '100%', marginBottom: 10 }}
                          onClick={() => setShowFinishModal('block')}
                          disabled={verifyTimeVideo() || !!roomSession?.token}
                          title={
                            roomSession?.token
                              ? 'O atendimento não pode ser finalizado enquanto a vídeo chamada estiver acontecendo!'
                              : 'Finalizar o atendimento'
                          }
                        >
                          {translate('medicalRecord.finishAttendance')}
                        </Button>
                        {isTotalpass && (
                          <S.ScheduleButtonWrapper
                            className={hasCredits ? 'has-credits' : ''}
                          >
                            {hasCredits && (
                              <div className="custom-tooltip">
                                Para o sucesso do bem-estar, marque agora a
                                próxima consulta.
                                <br />
                                Facilite o engajamento do paciente e mantenha o
                                acompanhamento em dia.
                              </div>
                            )}
                            <Button
                              color="primary-light"
                              type="button"
                              size="normal"
                              styles={{ width: '100%', marginBottom: 0 }}
                              onClick={() =>
                                hasCredits && setShowSchedulingModal(true)
                              }
                              disabled={!hasCredits}
                              title={
                                hasCredits
                                  ? translate(
                                      'newAnalysis.scheduleNextAppointment'
                                    )
                                  : translate('newAnalysis.noCreditsToSchedule')
                              }
                            >
                              {translate(
                                'newAnalysis.scheduleNextAppointmentButton'
                              )}
                            </Button>
                          </S.ScheduleButtonWrapper>
                        )}

                        <Button
                          color="danger"
                          type="button"
                          size="normal"
                          styles={{ width: '100%' }}
                          disabled={verifyTimeVideo() || !!roomSession?.token}
                          title={
                            roomSession?.token
                              ? 'O atendimento não pode ser cancelado enquanto a vídeo chamada estiver acontecendo!'
                              : 'Cancelar o atendimento'
                          }
                          onClick={() => {
                            setState({ ...state, message: '' })
                            setShowCancelModal('block')
                          }}
                        >
                          {translate('medicalRecord.cancelAppointment')}
                        </Button>

                        <Button
                          color="success"
                          type="button"
                          size="normal"
                          icon={whatsappIcon}
                          iconStyles={{ width: 20, marginRight: 15 }}
                          styles={{ width: '100%', marginTop: 10 }}
                          onClick={() => {
                            handleOpenWhatsApp()
                            handleClickTime()
                          }}
                          disabled={appointment?.status === 'pending'}
                          title={translate('newAnalysis.startWhatsAppChat')}
                        >
                          {translate('medicalRecord.initChat')}
                        </Button>
                      </>
                    )}

                    {appointment?.status === 'started' && (
                      <Button
                        color="success"
                        type="button"
                        size="normal"
                        icon={videoIcon}
                        iconStyles={{ width: 18, marginRight: 15 }}
                        styles={{ width: '100%', marginTop: 10 }}
                        title={
                          roomSession?.token
                            ? 'A vídeo chamada está em andamento!'
                            : 'Iniciar video chamada interna com o paciente'
                        }
                        onClick={() => {
                          setShowPermissionsModal(true)
                        }}
                        disabled={
                          appointment?.status === 'pending' ||
                          !!roomSession?.token
                        }
                      >
                        {translate('medicalRecord.initVideo')}
                      </Button>
                    )}
                  </div>
                </S.TopContent>
                <S.Menu>
                  <ul>
                    {menuItems.map((item: any, key: number) => {
                      if (appointment) {
                        if (item.id === 'Scheduling' && !isTotalpass) {
                          return null
                        }
                        if (item.id === 'chat' && !medicalRecordChatEnabled) {
                          return null
                        }

                        return item.by.includes(appointment?.specialty_slug) ? (
                          <S.MenuList
                            key={item.id}
                            className={key === selectedMenu ? 'active' : ''}
                          >
                            <button
                              type="button"
                              onClick={() => setSelectedMenu(key)}
                            >
                              {item.title}
                              {item.id === 'chat' &&
                                twilioChatForMenu.unreadCount > 0 &&
                                selectedMenu !== 0 && (
                                  <S.MenuUnreadBadge
                                    aria-label={`${twilioChatForMenu.unreadCount} mensagens não lidas`}
                                  >
                                    {twilioChatForMenu.unreadCount > 99
                                      ? '99+'
                                      : twilioChatForMenu.unreadCount}
                                  </S.MenuUnreadBadge>
                                )}
                            </button>
                          </S.MenuList>
                        ) : null
                      }
                    })}
                  </ul>
                </S.Menu>
              </Card>
            </Grid>
            <Grid
              item
              xs={12}
              md={9}
              style={{ padding: '2px 6px', order: verifyScrren ? 3 : 2 }}
            >
              {showPsicoReminder &&
                appointment?.specialty_slug === 'psicologo' &&
                videoCallOver2Min && (
                  <S.ReminderContainer>
                    <div className="reminder-icon">
                      <img src={alertCircleIcon} alt="Alerta" />
                    </div>
                    <div className="reminder-content">
                      <h4 className="reminder-title">Lembrete</h4>
                      <p className="reminder-text">
                        Lembre seu paciente de, se possível, responder a nossa
                        pesquisa anual de avaliação do serviço de psicologia.
                      </p>
                      <button
                        type="button"
                        className="reminder-copy-btn"
                        onClick={handleCopyPsicoLink}
                      >
                        Copiar link
                      </button>
                    </div>
                    <button
                      type="button"
                      className="reminder-close"
                      onClick={handleDismissPsicoReminder}
                      aria-label="Fechar lembrete"
                    >
                      X
                    </button>
                  </S.ReminderContainer>
                )}
              <Card>
                {selectedMenu !== 10 && (
                  <S.PatientContent>
                    <div className="PatientContent--header">
                      <div>
                        {appointment?.user_country === 'BR' ? (
                          <>
                            {!appointment?.user_social_name && (
                              <h3>
                                {normalizeName(
                                  appointment?.user_social_name || ''
                                )}
                              </h3>
                            )}

                            <h4>
                              {translate('medicalRecord.fullName')}:{' '}
                              {appointment?.user_name}
                            </h4>
                          </>
                        ) : (
                          <div
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                borderRight: '2px solid #000',
                                paddingRight: '10px',
                              }}
                            >
                              {appointment?.user_social_name && (
                                <h3>
                                  {normalizeName(
                                    appointment?.user_social_name || ''
                                  )}
                                </h3>
                              )}

                              <h4>
                                {translate('medicalRecord.fullName')}:{' '}
                                {appointment?.user_name}
                              </h4>
                            </div>

                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                paddingLeft: '10px',
                                gap: '5px',
                              }}
                            >
                              <PublicIcon fontSize="large" />
                              <span>
                                {translate('newAnalysis.globalPatient')}
                              </span>
                            </div>
                          </div>
                        )}
                        <p>
                          <span>{translate('medicalRecord.age')}</span>
                          {`${getAge(userData?.birthdate || '')} anos`}
                          <br />
                          <span>{translate('medicalRecord.bmi')}</span>
                          {calcIMC(userMedical?.height, userMedical?.weight)
                            ? `${calcIMC(
                                userMedical?.height,
                                userMedical?.weight
                              )} kg/m²`
                            : translate('medicalRecord.unavailable')}
                          <br />
                          <span>{translate('medicalRecord.gender')}</span>
                          {userData?.gender === 'male' &&
                            translate('medicalRecord.male')}
                          {userData?.gender === 'female' &&
                            translate('medicalRecord.female')}

                          {userData?.gender === null &&
                            translate('medicalRecord.uninformed')}
                          <br />
                          <span>{translate('medicalRecord.birthdate')}</span>
                          {formatLocal(userData?.birthdate, 'dd/MM/yyyy')}
                          <br />
                          <span>{translate('medicalRecord.weight')}</span>
                          {`${userMedical?.weight || ''} kg`}
                          <br />
                          <span>{translate('medicalRecord.height')}</span>
                          {`${userMedical?.height || ''} cm`}
                          <br />

                          {/* {schedule?.patient?.company?.name && (
                     <>
                       <span>{translate('medicalRecord.company')}</span>
                       {schedule?.patient?.company?.name}
                       <br />
                     </>
                   )} */}
                        </p>
                      </div>
                      <div className="PatientContent--contact">
                        <h4>{translate('medicalRecord.emergencyContact')}</h4>
                        <p>
                          <span>
                            {translate('medicalRecord.emergencyContactName')}
                          </span>
                          {userData?.emergency_contact?.contact_name
                            ? userData?.emergency_contact?.contact_name
                            : translate('medicalRecord.uninformed')}
                        </p>
                        <p>
                          <span>
                            {translate('medicalRecord.emergencyContactPhone')}
                          </span>
                          {userData?.emergency_contact?.contact_name
                            ? telephoneMask(
                                userData?.emergency_contact?.contact_phone
                              )
                            : translate('medicalRecord.uninformed')}
                        </p>
                        <p>
                          <span>
                            {translate(
                              'medicalRecord.emergencyContactRelationship'
                            )}
                          </span>
                          {userData?.emergency_contact?.contact_name
                            ? userData?.emergency_contact?.contact_relationship
                            : translate('medicalRecord.uninformed')}
                        </p>
                      </div>
                    </div>
                    <Global.Line />
                  </S.PatientContent>
                )}

                {selectedMenu === 0 && medicalRecordChatEnabled && (
                  <ChatPatient
                    doctorName={doctorName}
                    scheduleData={appointment}
                    scheduleUUID={appointment?.id}
                    twilioChatFromParent={twilioChatForMenu}
                  />
                )}
                {selectedMenu === 1 && appointment && (
                  <Resume
                    doctorName={doctorName}
                    specialtyName={appointment?.specialty_name ?? ''}
                    scheduleId={appointment?.id}
                    medicalRecord={userMedical}
                    symptoms={appointment?.symptoms}
                  />
                )}
                {selectedMenu === 2 && (
                  <Analysis
                    doctorName={doctorName}
                    scheduleUUID={appointment?.id}
                    scheduleData={appointment}
                  />
                )}
                {selectedMenu === 3 && (
                  <AnamneseNutri
                    doctorName={doctorName}
                    scheduleUUID={appointment?.id}
                    planSent={isMealPlanSent}
                  />
                )}
                {selectedMenu === 4 && (
                  <History
                    doctorName={doctorName}
                    scheduleUUID={appointment?.id}
                    schedule={appointment}
                    specialty={appointment.specialty_id}
                  />
                )}
                {selectedMenu === 5 && (
                  <>
                    <ImagesAndAttachments
                      doctorName={doctorName}
                      scheduleUUID={appointment?.id}
                    />
                  </>
                )}
                {selectedMenu === 6 && (
                  <>
                    <TermsPsico
                      autorization={appointment.authorization}
                      age={getAge(userData?.birthdate || '')}
                    />
                  </>
                )}
                {selectedMenu === 7 && (
                  <>
                    <NutritionalGuidance
                      doctorName={doctorName}
                      patientId={appointment?.user_id}
                      scheduleUUID={appointment?.id}
                      // nutritional={schedule?.nutritional?.attachment || false}
                      setLoading={setLoading}
                      // recipe={schedule?.nutritional?.recipe || false}
                    />
                  </>
                )}
                {selectedMenu === 8 && (
                  <>
                    <PsychologicalGuidance
                      doctorName={doctorName}
                      patientId={appointment?.user_id}
                      scheduleUUID={appointment?.id}
                      // attachment={schedule?.attachment || false}
                      setLoading={setLoading}
                    />
                  </>
                )}
                {selectedMenu === 9 && (
                  <>
                    <FoodMenu
                      doctorName={doctorName}
                      patientId={appointment?.user_id}
                      scheduleUUID={appointment?.id}
                      doctorId={appointment?.doctor_id}
                      planSent={isMealPlanSent}
                      // attachment={schedule?.attachment || false}
                      setLoading={setLoading}
                    />
                  </>
                )}
                {selectedMenu === 10 && isTotalpass && (
                  <>
                    <Scheduling
                      doctorName={doctorName}
                      scheduleUUID={appointment?.id}
                      schedule={appointment}
                      patientId={appointment?.user_id}
                      doctorId={appointment?.doctor_id}
                      onScheduleSuccess={() => setSelectedMenu(1)}
                    />
                  </>
                )}
              </Card>
            </Grid>
          </S.GridContent>
        </S.LeftContainer>
        {roomSession?.token && (
          <S.RightContainer>
            <VideoCallMeet
              onCloseRoom={clearVideoCallSession}
              onDoctorEndedCall={dispatchMeetVideoCallRating}
              token={roomSession?.token}
              roomSession={roomSession}
              schedulingId={appointment?.id}
            />
          </S.RightContainer>
        )}
      </S.Content>
      <>
        <div className="overlay" style={{ display: showCancelModal }} />
        <div className="modal-wrapper" style={{ display: showCancelModal }}>
          <div className="info-container">
            <ModalShow
              closeModal={hideModal}
              setDescription={setCancelDescription}
              description={cancelDescription}
              handleConfirm={handleCancelSchedule}
              setCustomDescription={setCustomDescription}
              customDescription={customDescription}
              cancelTracking={{
                schedulingId: appointment?.id,
                source: 'medical_record_analysis',
              }}
            />
          </div>
        </div>
      </>
      <>
        <div className="overlay" style={{ display: showFinishModal }} />
        <div className="modal-wrapper" style={{ display: showFinishModal }}>
          <div className="info-container">
            {(appointment?.specialty_slug === 'psicologo' ||
              appointment?.specialty_slug === 'nutricionista') && (
              <ModalShow
                closeModal={hideFinishModal}
                cancelModal={false}
                handleConfirm={handleSaveMedicalRecord}
                // setAccompaniment={setAccompaniment}
                // accompaniment={accompaniment}
              />
            )}
          </div>
        </div>
        <div className="overlay" style={{ display: showInitModal }} />
        <div className="modal-wrapper" style={{ display: showInitModal }}>
          <div className="info-container">
            <StartService
              closeModal={hideInitModal}
              handleConfirm={handleInitService}
            />
          </div>
        </div>

        <SideModal
          isOpen={showSchedulingModal}
          onClose={() => setShowSchedulingModal(false)}
          patientData={{
            id: appointment?.user_id || '',
            name: userData?.name || '',
            email: userData?.email || '',
            specialty: appointment?.specialty_slug || '',
          }}
          userCredits={userCredits}
          appointmentData={{
            doctorId: appointment?.doctor_id || '',
            specialtyId: appointment?.specialty_id || '',
            planId: appointment?.plan_id || '',
            country: appointment?.user_country || 'BR',
            timeZone: appointment?.user_time_zone || '',
            currentAppointment: appointment?.id || '',
          }}
          onRefresh={handleUpdateData}
        />

        {showPermissionsModal && (
          <VideoPermissions
            onClose={() => setShowPermissionsModal(false)}
            onConfirm={() => {
              if (showPermissions.camera && showPermissions.microphone) {
                setShowPermissionsModal(false)
                handleScrollToTop()
                handleClickTime()
                sendCallPush(appointment.id)
                initVideoCall(
                  appointment?.id,
                  state,
                  setLoading,
                  setState,
                  setRoomSession
                )
              }
            }}
            setShowPermissions={setShowPermissions}
            showPermissions={showPermissions}
          />
        )}
      </>
    </S.Container>
  )
}

export default NewMedicalRecord
